import { EntityCreatedModel } from '../models/base.model';
import { BackendHttpService } from './backendHttpService';
import { SkillEntry, SkillUpdateRequest, PersonTechnologyCreateRequest } from '../models/skill.model';
import { PersonTechnology } from '../models/technology.model';

export class PersonTechnologyService extends BackendHttpService {
  constructor() {
    super('person/tech');
  }

  async getPersonFavoriteTechnologies(userId: number): Promise<PersonTechnology[]> {
    try {
      return await this.get<PersonTechnology[]>(`/${userId}/favourite`);
    } catch (error) {
      console.error(`Error getting favourite technologies for user ${userId}:`, error);
      throw error;
    }
  }

  async getPersonSkills(personId: number): Promise<SkillEntry[]> {
    try {
      return await this.get<SkillEntry[]>(`/${personId}`);
    } catch (error) {
      console.error(`Error getting skills for person ${personId}:`, error);
      throw error;
    }
  }

  async updateSkill(skill: SkillUpdateRequest): Promise<void> {
    try {
      await this.put<SkillUpdateRequest, void>(skill, '/skill');
    } catch (error) {
      console.error('Error updating skill:', error);
      throw error;
    }
  }

  async updateFavourite(skill: SkillUpdateRequest): Promise<void> {
    try {
      await this.put<SkillUpdateRequest, void>(skill, '/favourite');
    } catch (error) {
      console.error('Error updating favourite:', error);
      throw error;
    }
  }

  async addPersonTechnology(personTechnology: PersonTechnologyCreateRequest): Promise<EntityCreatedModel> {
    try {
      return await this.post<PersonTechnologyCreateRequest, EntityCreatedModel>(personTechnology, '');
    } catch (error) {
      console.error('Error adding person technology:', error);
      throw error;
    }
  }
} 